function EyeIcon({ width, height, func, className }) {
	return (
		<svg
			className={className}
			height={`${height}em`}
			width={`${width}em`}
			onClick={func}
			viewBox='0 0 24 24'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle cx='12' cy='13' r='2' stroke-linejoin='round' />
			<path
				d='M12 7.5C7.69517 7.5 4.47617 11.0833 3.39473 12.4653C3.14595 12.7832 3.14595 13.2168 3.39473 13.5347C4.47617 14.9167 7.69517 18.5 12 18.5C16.3048 18.5 19.5238 14.9167 20.6053 13.5347C20.8541 13.2168 20.8541 12.7832 20.6053 12.4653C19.5238 11.0833 16.3048 7.5 12 7.5Z'
				// stroke='#000000'
				stroke-linecap='round'
				stroke-linejoin='round'
			/>
		</svg>
	);
}

export default EyeIcon;
